import { Component } from '@angular/core';

@Component({
    selector: 'app-scheduling',
    templateUrl: './scheduling.component.html',
    styleUrl: './scheduling.component.css',
    standalone: false
})
export class SchedulingComponent {

}